import { defineComponent as _defineComponent } from 'vue'
import {Address} from '@/modules/multiForm/shared/MultiformModels';
import {zipCodeFormat} from '@/filters/StringFilters';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressView',
  props: {
    address: null,
    fullAddress: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { address: Nullable<Address>, fullAddress: boolean }




return { __sfc: true,props, zipCodeFormat }
}

})